const data = [
  {
    url: 'https://www.instagram.com/p/B7ZBm26lba7/',
  },
  {
    url: 'https://www.instagram.com/p/BvHU_NJFRLx/',
  },
  {
    url: 'https://www.instagram.com/p/B9XbG7PlgPc/',
  },
  {
    url: 'https://www.instagram.com/p/Bwz4EsWl-D5/',
  },
  {
    url: 'https://www.instagram.com/p/Bw4i3AfFItX/',
  },
  {
    url: 'https://www.instagram.com/p/B0BwuT_ouV5/',
  },
  {
    url: 'https://www.instagram.com/p/B2NBSf7ovxf/',
  },
  {
    url: 'https://www.instagram.com/p/BxVL6AglmJb/',
  },
  {
    url: 'https://www.instagram.com/p/BrGgb3YFKbd/',
  },
  {
    url: 'https://www.instagram.com/p/BvaJK6ClP5R/',
  },
  {
    url: 'https://www.instagram.com/p/BwhvJ0GhvXc/',
  },
  {
    url: 'https://www.instagram.com/p/BrdNJ-4lKk4/',
  },
  {
    url: 'https://www.instagram.com/p/BzpYQaJoiPw/',
  },
  {
    url: 'https://www.instagram.com/p/ByH129wILiJ/',
  },
  {
    url: 'https://www.instagram.com/p/B-SH7n6FWi8/',
  },
  {
    url: 'https://www.instagram.com/p/B85zQGLBu0z/',
  },
];

export default data;
